import React from 'react';
import PropTypes from 'prop-types';
import { DimensionCategory, DimensionCategoryToColor, GeneralDimensionsConfig } from '../../../dimensionsUtils';
import css from './DimensionIcon.css';
import Icon, { IconSizes } from '../../../../components/foundations/Icon';

const DimensionIcon = ({ filter, category }) => {
    const iconName = GeneralDimensionsConfig[filter]?.icon || 'ai-line';
    return (
        <Icon
            className={css.dimensionIcon}
            name={iconName}
            size={IconSizes.SMALL}
            style={{
                '--icon-color': DimensionCategoryToColor[category] || DimensionCategoryToColor[DimensionCategory.OTHER],
            }}
        />
    );
};

DimensionIcon.propTypes = {
    filter: PropTypes.string,
    category: PropTypes.string,
};

export default DimensionIcon;
